export enum InsertLinksStatus {
    loadingOneLink,
    loadingMultipleLinks,
    failedToInsertOneLink,
    failedToInsertMultipleLinks,
    succeededToAddOneLink,
    succeededToAddMultipleLinks,
}
